import React, { useState } from "react";
import { Modal } from "antd";
import UseBktGrid from "../UseBktGrid";
import {
  USER_INFO,
  EVENT_PLANNING_USER_SELECTED_SCENARIOS,
} from "../../plannerConfig";

const ScenarioSelectionModal = ({
  visible,
  onCancel,
  destroyOnClose,
  scenarios,
  selectedScenarios,
  api,
  store,
  fromDate,
  toDate,
}) => {
  const gridConfigTop = {
    includeItemSelection: false,
    includeFilter: true,
    includePagination: false,
    includeRowCounts: false,
    includeEditDeleteCell: false,
    includeToolbar: false,
    hiddenColumns: ["user", "isReplan"],
  };

  const currentUser = store[USER_INFO].data;
  const { post, get } = api;

  const uniqueSelectedScenarios = selectedScenarios.reduce((acc, curr) => {
    return {
      ...acc,
      [curr.id]: curr,
    };
  }, {});

  const [localSelectedScenarios, updateLocalSelectedScenarios] = useState(
    uniqueSelectedScenarios
  );

  const scenariosMod = (scenarioList, funcCol) =>
    scenarioList.map(({ id, name, fromDate, toDate, ...rest }) => ({
      __FUNC_COLUMN: { customUI: funcCol },
      id,
      key: name,
      name,
      ...rest,
      fromDate: id > 0 && fromDate,
      toDate: id > 0 && toDate,
    }));

  const handleSelect = ({ checked, rowData }) => {
    if (Object.values(localSelectedScenarios).length === 5 && checked) {
      alert("Cannot Select +5 Scenarios");
      return;
    }
    const newObj = { ...localSelectedScenarios };

    if (checked) {
      newObj[rowData.id] = rowData;
    } else if (newObj[rowData.id]) {
      delete newObj[rowData.id];
    }

    updateLocalSelectedScenarios(newObj);
  };

  const meta = {
    columns: [
      { name: "__FUNC_COLUMN" },
      {
        name: "name",
        display_name: "Name",
        type: "string",
        enable_link: true,
        showEditIcon: true,
      },
      {
        name: "id",
        display_name: "ID",
        type: "string",
        width: 100,
      },
      { name: "comment", display_name: "Comment", type: "string" },
      {
        name: "owner",
        display_name: "Owner",
        type: "string",
      },
      { name: "fromDate", display_name: "From Date", type: "date" },
      { name: "toDate", display_name: "To Date", type: "date" },
    ],
  };

  const scenariosWithBoxSelectorColumn = scenariosMod(
    scenarios,
    "customCheckbox"
  );

  const buildRequestBody = () => {
    const eventPlanningUserScenarios = Object.values(
      localSelectedScenarios
    ).map((scenario) => {
      return {
        scenarioId: scenario.id,
      };
    });

    return {
      user: currentUser.id,
      fromDate,
      toDate,
      eventPlanningUserScenarios,
    };
  };

  return (
    <Modal
      title="Select Scenarios"
      visible={visible}
      onCancel={onCancel}
      destroyOnClose={destroyOnClose}
      maskClosable={true}
      width={"100%"}
      onOk={() => {
        post([EVENT_PLANNING_USER_SELECTED_SCENARIOS], {
          body: buildRequestBody(),
          callback: () => {
            get([EVENT_PLANNING_USER_SELECTED_SCENARIOS]);
          },
        });
        onCancel();
      }}
      bodyStyle={{
        height: "50vh",
        margin: 0,
        display: "flex",
      }}
    >
      <div style={{ flex: 1, "& #bktWrapper": { height: "100%" } }}>
        <UseBktGrid
          meta={meta}
          config={gridConfigTop}
          data={scenariosWithBoxSelectorColumn}
          noDataMessage="No Data Found"
          checkedState={localSelectedScenarios}
          onSelect={handleSelect}
        />
      </div>
    </Modal>
  );
};

export default ScenarioSelectionModal;
